export default "__VITE_ASSET__BOfjWypb__"